// Servicios de cobro activos por sucursal (sucursal.extras.servicios).
// Si una sucursal aún no tiene la configuración, ambos se consideran activos (como funcionaba antes).
export function serviciosDe(sucursal) {
  const s = sucursal?.extras?.servicios || {};
  return { pos: s.pos !== false, pedidosYa: s.pedidosYa !== false };
}
